import { Route } from "react-router";
import BuildOrderPage from "pages/OrderPages/BuildOrderPage/BuildOrderPage.tsx";
import ViewPriceEstimatesPage from "pages/OrderPages/ViewPriceEstimatesPage/ViewPriceEstimatesPage.tsx";
import ReviewOrderPage from "pages/OrderPages/ReviewOrderPage/ReviewOrderPage.tsx";
import NewOrderConfirmationPage from "pages/OrderPages/NewOrderConfirmation/NewOrderConfirmation.tsx";
import React from "react";
import NewOrderPage from "pages/OrderPages/NewOrderPage/NewOrderPage.tsx";
import { ProtectedRoute } from "routes/ProtectedRoute";
import { UserNavigationGroup, UserRole } from "types/declarations/enums.ts";

export const NewOrderQuoteRoutes = ProtectedRoute({
	path: "new-quote",
	featureFlag: "proQuoteEnabled",
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				index
				element={<NewOrderPage />}
			/>
			<Route
				path="build-order/:draftId?"
				element={<BuildOrderPage />}
			/>
			<Route
				path="view-price-estimates"
				element={<ViewPriceEstimatesPage isNewQuoteOrder />}
			/>
			<Route
				path="review-order"
				element={<ReviewOrderPage isNewQuoteOrder />}
			/>
			<Route
				path="confirmation/:draftId?"
				element={<NewOrderConfirmationPage isNewQuoteOrder />}
			/>
		</>
	)
});
